"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _count = _interopRequireDefault(require("../poly/count"));
var _menu = require("../utilities/menu");
var _styles2 = require("../utilities/styles");
var _button = _interopRequireDefault(require("../button"));
var _mobileMenuItem = _interopRequireDefault(require("./mobileMenuItem"));
var _excluded = ["url"],
  _excluded2 = ["component"],
  _excluded3 = ["component"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var MAX_ITEMS_PER_ROW = 4;
var getMaxHeight = function getMaxHeight(navigationHeight, numNav) {
  return "calc(100vh - ".concat(navigationHeight, " * ").concat(numNav - 1, ")");
};
var useClasses = (0, _styles.makeStyles)(function (_ref) {
  var _paper;
  var palette = _ref.palette,
    breakpoints = _ref.breakpoints,
    navigation = _ref.navigation,
    highContrast = _ref.accessibility.highContrast;
  return {
    paper: (_paper = {
      backgroundColor: palette.site.mobile.background,
      paddingBottom: '1.5em',
      paddingTop: '.5em',
      borderTop: "1px solid ".concat(palette.border.primary),
      borderTopLeftRadius: '.5em',
      borderTopRightRadius: '.5em',
      bottom: navigation.height,
      maxHeight: getMaxHeight(navigation.height, navigation.number)
    }, (0, _defineProperty2.default)(_paper, breakpoints.only('md'), {
      bottom: navigation.tablet.height
    }), (0, _defineProperty2.default)(_paper, breakpoints.up('md'), {
      bottom: navigation.desktop.height,
      maxHeight: getMaxHeight(navigation.tablet.height, navigation.tablet.number)
    }), (0, _defineProperty2.default)(_paper, breakpoints.up('lg'), {
      maxHeight: getMaxHeight(navigation.desktop.height, navigation.desktop.number)
    }), _paper),
    button: {
      padding: 0,
      gridRow: 1,
      color: palette.site.mobile.contrastText,
      '&:hover, &:focus': {
        color: "".concat(palette.site.mobile.contrastText, " !important")
      }
    },
    buttonLabel: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-around',
      flexGrow: 1,
      textTransform: 'uppercase',
      textDecoration: 'none',
      fontStretch: 'condensed',
      fontWeight: 'bold',
      lineHeight: '1'
    },
    buttonLabelActive: (0, _defineProperty2.default)({
      color: palette.text.active
    }, highContrast.mediaQuery('active'), {
      color: 'HighlightText !important',
      '-ms-high-contrast-adjust': 'none'
    }),
    buttonClose: {
      width: '1em',
      display: 'flex',
      alignSelf: 'center',
      marginBottom: '1em',
      '&:focus': {
        color: palette.site.mobile.contrastText
      }
    },
    gridContainer: (0, _defineProperty2.default)({
      display: 'grid',
      gridTemplateColumns: function gridTemplateColumns(_ref2) {
        var numOverMax = _ref2.numOverMax,
          numItems = _ref2.numItems;
        return "repeat(".concat(numOverMax ? MAX_ITEMS_PER_ROW : numItems, ", 1fr)");
      },
      width: '100%',
      margin: 0,
      gridGap: '0.5em',
      paddingLeft: '.5em',
      paddingRight: '.5em',
      justifyItems: 'center'
    }, breakpoints.only('sm'), {
      paddingLeft: '4.5em',
      paddingRight: '4.5em'
    }),
    menuDropdownItem: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center'
    },
    menuText: {
      '&:hover, &:focus': {
        color: palette.primary.contrastText,
        textDecoration: 'none'
      }
    },
    itemContainer: {
      width: '100%'
    }
  };
}, {
  classNamePrefix: 'TCUISiteSlideDrawer'
});
var reducer = function reducer(setMenu, title) {
  return function (state, action) {
    switch (action.type) {
      case 'close':
        setMenu({
          openItem: ''
        });
        return (0, _extends2.default)({}, state, {
          openItem: ''
        });
      case 'open':
        setMenu({
          openItem: title
        });
        return (0, _extends2.default)({}, state, {
          openItem: title
        });
      default:
        throw new Error();
    }
  };
};
var SlideDrawer = function SlideDrawer(_ref3) {
  var item = _ref3.item,
    items = _ref3.items,
    ButtonProps = _ref3.ButtonProps,
    MenuItemProps = _ref3.MenuItemProps,
    setMenu = _ref3.setMenu,
    openMenu = _ref3.openMenu,
    renderMenuItemImage = _ref3.renderMenuItemImage,
    getItemKey = _ref3.getItemKey;
  var drawerRef = (0, _react.useRef)(null);
  var _useReducer = (0, _react.useReducer)(reducer(setMenu, (0, _menu.getItemLabel)(item)), {
      openItem: openMenu
    }),
    _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
    dispatch = _useReducer2[1];
  var isActive = openMenu.openItem === (0, _menu.getItemLabel)(item);
  var numItems = (0, _count.default)(items);
  var numOverMax = numItems > MAX_ITEMS_PER_ROW;
  var _classes = useClasses({
    numOverMax: numOverMax,
    numItems: numItems
  });
  var handleOpen = function handleOpen() {
    return dispatch({
      type: 'open'
    });
  };
  var handleClose = function handleClose() {
    return dispatch({
      type: 'close'
    });
  };
  var handleClick = function handleClick() {
    handleClose();
    if (openMenu.openItem !== (0, _menu.getItemLabel)(item)) {
      handleOpen();
    }
  }; // eslint-disable-next-line no-unused-vars

  var url = item.url,
    cleanItem = (0, _objectWithoutProperties2.default)(item, _excluded);
  var _ButtonProps$componen = ButtonProps.component,
    MenutItem = _ButtonProps$componen === void 0 ? _mobileMenuItem.default : _ButtonProps$componen,
    restButtonProps = (0, _objectWithoutProperties2.default)(ButtonProps, _excluded2);
  var _MenuItemProps$compon = MenuItemProps.component,
    SubMenuItem = _MenuItemProps$compon === void 0 ? _mobileMenuItem.default : _MenuItemProps$compon,
    restMenuItemProps = (0, _objectWithoutProperties2.default)(MenuItemProps, _excluded3);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(MenutItem, (0, _extends2.default)({
    item: cleanItem,
    "aria-label": (0, _menu.getItemLabel)(item),
    "aria-haspopup": "true",
    onClick: handleClick
  }, restButtonProps, {
    classes: (0, _styles2.mergeClasses)({
      root: (0, _clsx2.default)(_classes.button, _classes.menuText),
      label: (0, _clsx2.default)(_classes.buttonLabel, (0, _defineProperty2.default)({}, _classes.buttonLabelActive, isActive))
    }, ButtonProps.classes),
    isActive: isActive,
    renderMenuItemImage: renderMenuItemImage
  })), /*#__PURE__*/_react.default.createElement(_core.SwipeableDrawer, {
    disableSwipeToOpen: true,
    disableAutoFocus: true,
    ModalProps: {
      onRendered: function onRendered() {
        // For IOS Voiceover bug - https://www.applevis.com/forum/weird-focus-issue-safari
        var closeButton = drawerRef.current.querySelector('.btn-link');
        closeButton.focus();
      }
    },
    PaperProps: {
      role: 'dialog'
    },
    classes: {
      paper: _classes.paper
    },
    anchor: "bottom",
    open: isActive,
    onOpen: handleOpen,
    onClose: handleClose,
    ref: drawerRef
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    classes: {
      root: (0, _clsx2.default)('btn-link', _classes.buttonClose)
    },
    onClick: handleClose,
    "aria-label": "Close"
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['tcs', 'arrow-down-rounded'],
    size: "1x"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _classes.gridContainer,
    spacing: numOverMax ? 0 : 2,
    container: true,
    justify: "space-around"
  }, items.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _classes.itemContainer,
      key: getItemKey(item, i)
    }, /*#__PURE__*/_react.default.createElement(SubMenuItem, (0, _extends2.default)({
      item: item
    }, restMenuItemProps, {
      classes: (0, _styles2.mergeClasses)({
        root: (0, _clsx2.default)(item.classes, _classes.menuDropdownItem),
        text: _classes.menuText
      }, MenuItemProps.classes),
      bordered: true,
      renderMenuItemImage: renderMenuItemImage
    })));
  }))));
};
SlideDrawer.propTypes = {
  item: _propTypes.default.object.isRequired,
  items: _propTypes.default.array,
  setMenu: _propTypes.default.func.isRequired,
  openMenu: _propTypes.default.object,
  renderMenuItemImage: _propTypes.default.func,
  getItemKey: _propTypes.default.func,
  ButtonProps: _propTypes.default.object,
  MenuItemProps: _propTypes.default.object
};
SlideDrawer.defaultProps = {
  getItemKey: _menu.getItemKey,
  items: null,
  openMenu: {},
  renderMenuItemImage: function renderMenuItemImage() {
    return null;
  },
  ButtonProps: {},
  MenuItemProps: {}
};
var _default = SlideDrawer;
exports.default = _default;